module.exports = __webpack_public_path__ + "assets/img/11_940_big.c0717966.jpg";